import React from 'react';
import { XCircle } from 'react-feather';
import CollaboratorManager from './CollaboratorManager';

interface Props {
  questionId: string;
  onClose: () => void;
}

const CollaborateModal: React.FC<Props> = ({ questionId, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Collaborators</h2>
          <button className="btn-close" onClick={onClose}><XCircle size={18} /></button>
        </div>
        <CollaboratorManager questionId={questionId} />
      </div>
    </div>
  );
};

export default CollaborateModal;
